import React, {Component} from 'react'
import {Badge, Nav, Navbar, NavDropdown, NavLink} from "react-bootstrap";
import {Cookies, withCookies} from "react-cookie";
import {withTranslation} from 'react-i18next';
import {Tooltip as ReactTooltip} from "react-tooltip";
import {HiOutlineClipboardList} from "react-icons/hi";
import {RiAccountPinCircleFill, RiAdminFill} from 'react-icons/ri';
import {GiExitDoor} from "react-icons/gi";
import {instanceOf} from "prop-types";
import ApiV0 from "../services/ApiV0";
import {analyticsEvent} from '../_common/AnalyticsManager';
import {setCookies} from "../services/CookiesUtils";
import CSearchBar from "../core/CSearchBar";
import './styles/CHead2.css'
import {GG_CATEGORY} from "../services/constant";
import {MdAdminPanelSettings, MdShoppingCart} from "react-icons/md";
import _ from "lodash";
import {isNotEmpty, isSet} from "../services/commonUtil";
import CAdminNav from "../admin/CAdminNav";
import CLangToggle from "../_common/CLangToggle";

const DYNAMIC_MENU_PREFIX = "dMenu";
const verbose = false;


class CHead2 extends Component {
    /* no more compatible with react 19
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };

     */

    constructor(props) {
        super(props);
        setCookies(props.cookies);// for changeLang
        this.wrapper = React.createRef();
        this.state = {};
    }

    isConnected() {
        return (this.props.me && this.props.me.profile && this.props.me.profile.displayName)
    }

    isAdmin() {
        return (this.isConnected() && this.props.me.profile.isAdmin === true)
    }

    show(menuEntry) {
        let newState = {...this.state};
        Object.keys(newState).forEach((key) => {
            if (key.startsWith(DYNAMIC_MENU_PREFIX)) {
                newState[key] = false;
            }
        });
        newState[menuEntry] = true;
        this.setState(newState);
    }

    hide(menuEntry) {
        setTimeout(() => {
            let state = this.state;
            state[menuEntry] = false;
            this.setState(state);
        }, 500); // delay dropdown hide
    }

    logoutUser() {
        const propsMe = this.props.me;
        const isConnected = propsMe && propsMe.profile;
        const connectedUser = isConnected ? propsMe.profile.displayName : "Anonyme";
        const evt = `logout`;
        analyticsEvent(GG_CATEGORY.AUTH, evt, evt, connectedUser);
        document.location.href = "/api/v0/logout";
    }

    render() {
        const {t} = this.props;
        const amIAdmin = this.isAdmin();
        const adminActive = amIAdmin && window.location.pathname.startsWith('/admin');
        const connectedMenu = this.renderConnectedMenu();
        const disconnectedMenu = this.renderDisconnectedMenu(t);
        const connectMenu = this.isConnected() ? connectedMenu : disconnectedMenu;
        const cartMenu = this.renderCartMenu(t);
        const topMenusLarge = this.renderTopMenus(true);
        const topMenusSmall = this.renderTopMenus(false);
        return (<>
            <div className="headTop">
                <LogoSearchNavBar/>
                <Navbar sticky="top" bg="light" expand="lg" className="v2Navbar heightNavBar">
                    <div className="v2Logo smallScreen"><a href="/">
                        <img
                            src="/v2/logo/logo_v2_sorciere_etoiles.png"
                            className="d-inline-block align-top v2LogoImage"
                            alt="Logo"
                        />
                    </a></div>
                    <Nav className="me-auto"></Nav>
                    <Navbar.Toggle/>
                    <Navbar.Collapse className="justify-content-end">
                        <Nav className="me-auto"></Nav>
                        {topMenusLarge}
                        {topMenusSmall}
                        <Nav className="me-auto"></Nav>
                        {connectMenu}
                        {amIAdmin ? (
                            <Nav><a href="/admin"
                                    title="admin"><RiAdminFill/><MdAdminPanelSettings/> Admin</a></Nav>) : null}
                        <Nav.Link disabled>&#160;</Nav.Link>
                        {cartMenu}
                        <Nav.Link disabled>&#160;</Nav.Link>
                        <CLangToggle/>
                        <div  className="smallScreen"><CSearchBar/></div>
                    </Navbar.Collapse>
                </Navbar>
                {adminActive ? (<CAdminNav/>) : null}
            </div>
            <div className={"clearBoth"}/>
        </>);
    }

    renderTopMenus(isLarge) {
        const lang = ApiV0.lang;
        const {menusTree} = this.props;
        if (isLarge) {
            return menusTree
                .filter(menuEntry => isNotEmpty(menuEntry?.fr))
                .map((menuEntry, index) => this.buildLargeScreenSectionDropDown(lang, menuEntry, index));
        }
        return menusTree
            .filter(menuEntry => isNotEmpty(menuEntry?.fr))
            .map((menuEntry, index) => this.buildSmallScreenSectionDropDown(lang, menuEntry, index));
    }

    renderCartMenu() {
        const {t} = this.props;
        const cartCount = this.getCartCount();
        return <Nav.Link title={t('menu.mycart')} disabled={cartCount < 1} href="/cart">
            <MdShoppingCart/> {t('menu.cart')}<Badge bg="light"
                                                     className="chBadge cartBadge">{cartCount}</Badge>
        </Nav.Link>;
    }

    getCartCount() {
        const {"me": propsMe} = this.props;
        const cart = propsMe?.cart;
        const reducerAdd = (accumulator, currentValue) => accumulator + currentValue;
        const validEntries = _.get(cart, 'entries', []).filter(e => e.quantity > 0 && e.quantityMax > 0);
        return validEntries.map(e => (Math.min(e.quantity, e.quantityMax))).reduce(reducerAdd, 0);
    }

    renderDisconnectedMenu(t) {
        return <>
            <ReactTooltip anchorId="menuSubscribeBis"/>
            <ReactTooltip anchorId="menuLoginBis"/>
            <Nav.Link as={NavLink}
                      href="/login"
                      id="menuLoginBis"
            >{t('menu.login.label')}</Nav.Link>
            <Nav.Link as={NavLink}
                      href="/register"
                      id="menuSubscribeBis"
            >{t('menu.subscribe.label')}</Nav.Link>
        </>;
        // data-tooltip-content={t('menu.login.tooltip')}
        // data-tooltip-content={t('menu.subscribe.tooltip')}
    }

    renderConnectedMenu() {
        const {t, "me": propsMe} = this.props;
        const isConnected = propsMe?.profile;
        const connectedUser = isConnected ? propsMe.profile.displayName : t('menu.anonymous');
        const hasCommands = isConnected && propsMe.commands && propsMe.commands.length > 0;
        const commandActive = window.location.pathname.startsWith('/command');
        const navDropdownAccountTitle = (<span><RiAccountPinCircleFill/> {t('menu.account')}</span>);
        const dynMenuAccount = `${DYNAMIC_MENU_PREFIX}Account`;
        return <>
            <Nav className="largeScreen">

                <NavDropdown title={navDropdownAccountTitle}
                             show={this.state[dynMenuAccount]}
                             onMouseEnter={this.show.bind(this, dynMenuAccount)}
                             onMouseLeave={this.hide.bind(this, dynMenuAccount)}
                             className="largeScreen"
                >
                    {hasCommands ? (
                        <NavDropdown.Item as={NavLink}
                                          active={commandActive}
                                          href="/command/all"
                        ><HiOutlineClipboardList/> {t('menu.commands')}</NavDropdown.Item>
                    ) : null
                    }
                    <NavDropdown.Item as={NavLink} href="/me"
                    ><RiAccountPinCircleFill/> {t('menu.profile')} - {connectedUser}</NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} onClick={this.logoutUser.bind(this)}
                    ><GiExitDoor/> {t('menu.logout')}</NavDropdown.Item>
                </NavDropdown>

            </Nav>

            <span className="smallScreen topMenuContainer"><span
                className="topMenuHeadTitle">{navDropdownAccountTitle}</span><br/>
                {hasCommands ? (
                    <div className="topMenuEntry">
                        <a href="/command/all"><HiOutlineClipboardList/> {t('menu.commands')}</a><br/>
                    </div>
                ) : null
                }

                <div className="topMenuEntry">
                        <a href="/me"><RiAccountPinCircleFill/> {t('menu.profile')} - {connectedUser}</a><br/>
                </div>

                <div className="topMenuEntry">
                        <span onClick={this.logoutUser.bind(this)}><GiExitDoor/> {t('menu.logout')}</span><br/>
                </div>
            </span>
        </>;
    }

    buildLargeScreenSectionDropDown(lang, menuEntry, sectionIndex) {
        const isEn = lang === 'en';
        const dynMenuTitle = isEn ? menuEntry.en : menuEntry.fr;
        const dynMenuId = DYNAMIC_MENU_PREFIX + dynMenuTitle;
        verbose && console.log(`dynMenuId:${dynMenuId}`)
        return <NavDropdown id={dynMenuId}
                            key={"ls" + sectionIndex}
                            title={dynMenuTitle}
                            renderMenuOnMount={true}
                            show={this.state[dynMenuId]}
                            onMouseEnter={this.show.bind(this, dynMenuId)}
                            onMouseLeave={this.hide.bind(this, dynMenuId)}
                            className="largeScreen"
        >
            {menuEntry.sections.map((section, index) => {
                const menuSectionId = `${dynMenuId}-${index}`;
                const menuSectionTitle = isEn ? section.en_title : section.title;
                const menuSectionSlug = isEn ? section.en_slug : section.slug;
                verbose && console.log(`   >section id:${menuSectionId}`)
                if (isSet(menuSectionSlug)) {
                    return (
                        <NavDropdown.Item key={index} id={menuSectionId}
                                          href={`/listing/${menuSectionSlug}`}>
                            {menuSectionTitle}
                        </NavDropdown.Item>
                    );
                }
                return null; // no slug == no menu
            })}
        </NavDropdown>;
    }


    buildSmallScreenSectionDropDown(lang, menuEntry, sectionIndex) {
        const isEn = lang === 'en';
        const dynMenuTitle = isEn ? menuEntry.en : menuEntry.fr;
        return <span key={"s" + sectionIndex} className="smallScreen topMenuContainer"><span
            className="topMenuHeadTitle">{dynMenuTitle}</span><br/>
            {menuEntry.sections.map((section, index) => {
                const menuSectionTitle = isEn ? section.en_title : section.title;
                const menuSectionSlug = isEn ? section.en_slug : section.slug;
                if (isSet(menuSectionSlug)) {
                    return (<div key={index} className="topMenuEntry">
                        <a href={`/listing/${menuSectionSlug}`}>
                            {menuSectionTitle}
                        </a><br/>
                    </div>);
                }
                return null; // no slug == no menu
            })}
        </span>;
    }
}

CHead2.propTypes = {
    cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(withTranslation('common')(CHead2));

const SiteLogoDiv = () => <div className="v2Logo"><a href="/">
    <img
        src="/v2/logo/logo_v2_sorciere_etoiles.png"
        className="d-inline-block align-top v2LogoImage"
        alt="Logo"
    />
</a></div>;
const LogoSearchNavBar = () => <>
    <Navbar sticky="top" bg="light" expand="lg" className="v2Navbar topNavBar">
        <Navbar.Collapse className="justify-content-end">
            <SiteLogoDiv/>
            <Nav className="me-auto"></Nav>
            <Nav.Link disabled>&#160;</Nav.Link>
            <CSearchBar className="largeScreen"/>
        </Navbar.Collapse>
    </Navbar>
</>;